import React from "react";

export const TextareaField = ({ question, value, onChange, lang }) => (
  <textarea
    className="dq-textarea"
    placeholder={
      lang === "ar" ? question.placeholder_arabic || "" : question.placeholder || ""
    }
    value={value || ""}
    onChange={(e) => onChange(e.target.value)}
    dir={lang === "ar" ? "rtl" : "ltr"}
  />
);
